import { BezierLineMarkerStateManager } from '../bezier/bezierLineMarkerStateManager'

class MeasurementMarkerStateManager extends BezierLineMarkerStateManager {
  protected _capLength = 7.5

  constructor(marker) {
    super(marker)
  }

  set capLength(newCapLength: number) {
    this._capLength = newCapLength
  }

  get capLength(): number {
    return this.scalingRatio !== 0 ? this._capLength * this.scalingRatio : this._capLength
  }
}

export { MeasurementMarkerStateManager }
